module.exports = __webpack_public_path__ + "static/media/S_9.50ec4eb0.png";